export function noPaddingCard(blockCardBox) {
  const padding = !blockCardBox && blockCardBox !== null ? 'no-cards-padding' : 'cards-padding'
  return padding
}

export function backgroundColorDiv(showcaseCircles, quote) {
  const background = showcaseCircles || quote ? 'transparent' : ''
  return background
}

export function hideImageMobileClass(hideImageMobile) {
  const hiddenClass = hideImageMobile ? 'hide-mobile' : ''
  return hiddenClass
}
